import { TranslationLabels } from "translations/TranslationLabels";

export enum BoardRoleEnum {
  Owner = 1,
  Member = 2,
  Visitor = 3,
  DeputyMember = 4,
  DeputyVisitor = 5,
  Admin = 6,
}

export function getBoardRoleName(role: BoardRoleEnum, i18n: TranslationLabels): string {
  switch (role) {
    case BoardRoleEnum.Owner:
      return i18n.Owner;
    case BoardRoleEnum.Member:
      return i18n.Member;
    case BoardRoleEnum.Visitor:
      return i18n.Visitor;
    case BoardRoleEnum.DeputyMember:
      return i18n.DeputyMember;
    case BoardRoleEnum.DeputyVisitor:
      return i18n.DeputyVisitor;
    case BoardRoleEnum.Admin:
      return i18n.Admin;
    default:
      return "";
  }
}
